import Icon from '@atoms/Icon/Icon';

interface Props {
  readonly title: string;
  readonly subTitle?: string;
  readonly onClick: () => void;
  readonly dataTestId?: string;
}

const SelectorButton = ({
  title,
  subTitle,
  dataTestId = 'Selector-Button',
  onClick,
}: Props) => (
  <button
    type="button"
    className="flex w-full rounded-[10px] border-transparent bg-grey-100 p-5 transition-all dark:bg-grey-600 md:py-[15px] lg:border lg:py-3 lg:hover:cursor-pointer lg:hover:border lg:hover:border-yellow"
    onClick={onClick}
    data-testid={dataTestId}
  >
    <div className="flex w-full flex-row items-center justify-between">
      <span className="flex flex-col gap-[9px] text-left md:gap-1">
        <span
          className="body-four text-grey-450 dark:text-grey-500"
          data-testid={`${dataTestId}-Title`}
        >
          {title}
        </span>
        {subTitle && (
          <span
            className="text-black-100 dark:text-white"
            data-testid={`${dataTestId}-Subtitle`}
          >
            {subTitle}
          </span>
        )}
      </span>

      <Icon
        name="arrow_right"
        colorClassName="text-black-100 dark:text-yellow"
      />
    </div>
  </button>
);

export default SelectorButton;
